import { FC, PropsWithChildren } from "react";
import { StyledText, Types } from "@emonvia/web-components";

export const BoldText: FC<PropsWithChildren<{ semibold?: boolean }>> = ({
  children,
  semibold = false
}) => (
  <StyledText
    type={semibold ? Types.ns_16_sb : Types.ns_16_b}
    text={children}
    style={{ display: "inline-block" }}
  />
);
